import { render, staticRenderFns } from "./CoozzyEditIcon.vue?vue&type=template&id=1927aae7&scoped=true"
import script from "./CoozzyEditIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyEditIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyEditIcon.vue?vue&type=style&index=0&id=1927aae7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1927aae7",
  null
  
)

export default component.exports